import { createMuiTheme } from "@material-ui/core/styles";

const FlagstoneTheme = createMuiTheme({
  typography: {
    fontFamily: "\"Helvetica\", \"Arial\", sans-serif"
  },
  palette: {
    secondary: {
      main: '#fafafa',
      secondary: '#4654FB'
    },
    primary: {
      main: '#4654FB',
      secondary: '#fafafa'
    },
    lightGreen:{
      main:'#5CC958',
      secondary:'#fafafa'
    }
  },
});

export default FlagstoneTheme;